export default __webpack_public_path__ + "static/media/ceta_marker.d1a19b17.svg";